import { render, staticRenderFns } from "./pane.vue?vue&type=template&id=61ab6d3a&scoped=true&"
import script from "./pane.vue?vue&type=script&lang=js&"
export * from "./pane.vue?vue&type=script&lang=js&"
import style0 from "./pane.vue?vue&type=style&index=0&id=61ab6d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab6d3a",
  null
  
)

export default component.exports